module.exports = __webpack_public_path__ + "static/media/Clustering Illusion - johnny-kaufman-kYlN3swKbSA-unsplash.42699846.jpg";